import { useEffect, useState } from 'react';

import { useDocumentTitle } from '@mantine/hooks';
import { useZoneContext } from '../../contexts/useZoneContext';

export interface IDocumentTitleProps {
    hideZoneName?: boolean;
    title?: string;
}

export function DocumentTitle({ title, hideZoneName }: IDocumentTitleProps) {
  const { zoneName } = useZoneContext();

  const displayTitle = `${!hideZoneName && zoneName ? `${zoneName} - ` : ''}${title ?? 'Checkmate'}`;

  useDocumentTitle(displayTitle);

  return null;
}